export const STATUS_CODES = {
  TOKEN_IS_REQUIRED: 103,
  INVALID_TOKEN: 104,
  VALIDATION_ERROR: 105,
  SUCCESS: 200,
  BAD_REQUEST: 400,
  ACCESS_DENIED: 110,
  UNAUTHORIZED: 401,
  PAGE_NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
};
